import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import FunnelLanding from './funnel/FunnelLanding';
import ApplicationForm from './funnel/ApplicationForm';
import ResultPage from './funnel/ResultPage';
import AdminLeads from './funnel/AdminLeads';
import { trackPageView } from './funnel/tracking';

// Fires a GA4 page_view on every SPA route change. gtag's automatic page_view
// is disabled in public/index.html — without this, GA4 only ever sees the
// initial document load and misses /apply and /result entirely.
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <RouteTracker />
        <Routes>
          {/* Entrepreneur Application Funnel — this microsite's whole purpose.
              FB Ad -> / -> /apply -> /result */}
          <Route path="/" element={<FunnelLanding />} />
          <Route path="/apply" element={<ApplicationForm />} />
          <Route path="/result" element={<ResultPage />} />

          {/* Internal lead review (passcode gated) */}
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
